import NewWindow from "react-new-window";
import ReactHlsPlayer from "react-hls-player";
import React, {Component} from "react";
import Button from "@material-ui/core/Button";
import Refresh from "@material-ui/icons/Refresh";
import CircularProgress from "@material-ui/core/CircularProgress";

class LivePlayer extends Component {

    state = {
        loading: false
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // console.log("nextState ", nextState)
        if (nextState.loading !== this.state.loading) {
            return true
        }
        return false;
    }

    onLoadStart(e) {
        e.target.volume = 0
    }

    reload = (e) => {

        this.setState({
            loading: true
        })

        let intervalArea = setTimeout(() => {
            this.setState({
                loading: false
            })
        }, 2000)
    }

    render() {
        console.log("url endpoint: ", this.props.src)
        return (

            <div>
                {this.state.loading ? <CircularProgress/> :
                    <div style={{border: "2px solid"}}>
                        <h2>{this.props.canonicalName}</h2>
                        <ReactHlsPlayer
                            src={this.props.src}
                            autoPlay={true}
                            controls={true}
                            onLoadStart={this.onLoadStart}
                            width="640px"
                            height="auto"
                        />
                        <div>
                            <Button variant="outlined" style={{margin: '5px'}} onClick={this.reload}>
                                <Refresh/>
                                reload
                            </Button>
                        </div>
                    </div>
                }
            </div>

        )
    }
}

export default LivePlayer;
